// import {
// 	SpeciesInvasivityService,
// 	SpeciesNativityService,
// 	SpeciesTypeService,
// } from "../../Services";

import {ServiceDrivenAutoCompleteFieldEditor} from "./FieldEditors/ServiceDrivenAutoCompleteFieldEditor";
import {ServiceDrivenDropDownFieldEditor} from "./FieldEditors/ServiceDrivenDropDownFieldEditor";

import {service as ConservationActionService} from "../../Services/ConservationActionService";
import {service as ConservationActionTypeService} from "../../Services/ConservationActionTypeService";
import {service as ConfirmationAgencyService} from "../../Services/ConfirmationAgencyService";
import {service as ConfirmationStatusService} from "../../Services/ConfirmationStatusService";
import {service as ContactService} from "../../Services/ContactService";
import {service as EnvironmentalBenefitService} from "../../Services/EnvironmentalBenefitService";
import {service as EcoregionService} from "../../Services/EcoregionService";
import {service as HucService} from "../../Services/HucService";
import {service as PermitTypeService} from "../../Services/PermitTypeService";
import {service as PermitService} from "../../Services/PermitService";
import {service as ProcedureService} from "../../Services/ProcedureService";
import {service as ProgramService} from "../../Services/ProgramService";
import {service as ProjectService} from "../../Services/ProjectService";
import {service as RiverService} from "../../Services/RiverService";
import {service as RelationshipService} from "../../Services/RelationshipService";
import {service as StakeholderTypeService} from "../../Services/StakeholderTypeService";
import {service as FunderService} from "../../Services/FunderService";
import {service as TagService} from "../../Services/TagService";


export const ContactFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ContactService);

export const ConservationActionFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ConservationActionService);
export const ConfirmationAgencyEditor = ServiceDrivenAutoCompleteFieldEditor(ConfirmationAgencyService);
export const ConfirmationStatusEditor = ServiceDrivenDropDownFieldEditor(ConfirmationStatusService);
export const HucFieldEditor = ServiceDrivenAutoCompleteFieldEditor(HucService);
export const RiverFieldEditor = ServiceDrivenAutoCompleteFieldEditor(RiverService);
export const EcoregionFieldEditor = ServiceDrivenAutoCompleteFieldEditor(EcoregionService);
export const TagFieldEditor = ServiceDrivenAutoCompleteFieldEditor(TagService);

export const EnvironmentalBenefitFieldEditor = ServiceDrivenAutoCompleteFieldEditor(EnvironmentalBenefitService);
export const FunderFieldEditor = ServiceDrivenAutoCompleteFieldEditor(FunderService);

export const PermitFieldEditor = ServiceDrivenAutoCompleteFieldEditor(PermitService);
export const PermitTypeFieldEditor = ServiceDrivenAutoCompleteFieldEditor(PermitTypeService);

export const ProcedureFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ProcedureService);

export const ProgramAutoCompleteFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ProgramService);

export const ProjectFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ProjectService);
export const StakeholderTypeEditor = ServiceDrivenDropDownFieldEditor(StakeholderTypeService);
export const RelationshipFieldEditor = ServiceDrivenDropDownFieldEditor(RelationshipService);
export const ConservationActionTypeFieldEditor = ServiceDrivenDropDownFieldEditor(ConservationActionTypeService);

export {OrganizationFieldEditor} from './FieldEditors/OrganizationFieldEditor';



